import type { Guide, GuideRecordHint } from '../types';

/**
 * S-24.10-02 — historia zmian zlecenia zwinięta pod metryką, pełna ze stronicowaniem i filtrem (decyzja z paczki
 * p. Mariusza 20.10, MIX-01; scenariusz e2e 26). DEMO/2026/10/H03 ma ponad 30 wpisów (także 30 starszych
 * z importu, `e2e/setup/scenario-state.mjs`). Nagrywarka tylko rozwija historię.
 */
const ORDER: GuideRecordHint = {
  description: 'dowolne zlecenie z historią zmian',
  listPath: '/user-offers',
  listFilter: { forklift: 'hide' },
};

export const guide: Guide = {
  flagKey: 'orderHistoryCollapsed',
  title: 'Historia zmian zwinięta, cała ze stronicowaniem i filtrem',
  whatItDoes:
    'Historia zmian na karcie zlecenia jest zwinięta do jednej linii: ile jest wpisów, kiedy, kto i co zmienił ostatnio i ile było decyzji ludzi. Rozwija się na żądanie — wybór pamięta przeglądarka. Rozwinięta pokazuje całą historię po 25 wpisów na stronie, a filtr zawęża ją do decyzji ludzi, wpisów systemu albo importu z TMS. Wcześniej karta pokazywała tylko 100 najnowszych wpisów i import co godzinę wypychał z nich decyzje.',
  audience: ['wszyscy, którzy oglądają kartę zlecenia'],
  presentationItems: ['S-24.10-02'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: ORDER,
      target: 'order-history-metric',
      title: 'Metryka zwiniętej historii',
      description: 'Liczba wpisów w tytule, ostatnia zmiana (kiedy, kto, co) i liczba decyzji ludzi.',
      action: 'Zjedź na dół karty zlecenia do „Historia zmian”.',
      recorder: { account: 'ftl', demo: { kind: 'order', number: 'DEMO/2026/10/H03' } },
    },
    {
      route: '/user-offers/:orderId/show',
      record: ORDER,
      target: 'order-history-filter-human',
      title: 'Cała historia z filtrem',
      description:
        'Po rozwinięciu wpisy idą po 25 na stronie („Nowsze” / „Starsze”). Filtr: wszystko, decyzje ludzi, system, import z TMS.',
      action: 'Kliknij „Rozwiń historię”, potem „Decyzje ludzi”.',
      recorder: {
        account: 'ftl',
        demo: { kind: 'order', number: 'DEMO/2026/10/H03' },
        actions: [{ kind: 'click', target: 'order-history-toggle' }],
      },
    },
  ],
};
